export const triggerModal = () => {
    const modalMessage = document.getElementById("modal-message");
    if (modalMessage) {
        // Add your modal logic here, for example:
        modalMessage.style.display = 'block'; // or use Bootstrap or any other modal logic
    }
};
